// This is required by apollo docs for some reason
export default () => null;
